import Loader from '@/external/components/Loader';

const Disabled: FC = () => (
  <div className="absolute inset-0 z-10 flex cursor-not-allowed items-center justify-center rounded-moon-s-sm bg-black/10">
    <Loader color="border-trunks" />
  </div>
);

export default Disabled;
